// extracted by mini-css-extract-plugin
export var buttonContainer = "_10-6";
export var centeredToolbar = "_10-4";
export var dashdraw = "_10-c";
export var emptyStateContainer = "_10-8";
export var emptyStateText = "_10-9";
export var flowEditor = "_10-0";
export var flowEditorContainer = "_10-7";
export var hovered = "_10-1";
export var leftPanel = "_10-3";
export var mainCanvasContainer = "_10-a";
export var minimap = "_10-b";
export var selectMode = "_10-2";
export var toolbarSeparator = "_10-5";